import Prose from '@frontend/storefront/components/prose';
import { useStorefrontData } from '@frontend/storefront/data';

export default function Page() {
  const { page } = useStorefrontData();
  if (!page) return null;
  return (
    <>
      <h1 className="mb-8 text-5xl font-bold">{page.title}</h1>
      <Prose className="mb-8" html={page.body} />
      <p className="text-sm italic">
        {`This document was last updated on ${new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }).format(new Date(page.updatedAt))}.`}
      </p>
    </>
  );
}
